module.exports = __webpack_public_path__ + "img/octalis_hd_bg.9b63f855.png";